"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_LINK_CUSTOM_PARAMS = exports.DEFAULT_HTTP_TIMEOUT_IN_MS = void 0;

var _Availability = _interopRequireDefault(require("MeetingsBase/models/Availability"));

var _dates = require("MeetingsBase/constants/dates");

var _enums = require("MeetingsBase/constants/enums");

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _DisplayInfo = _interopRequireDefault(require("MeetingsBase/models/DisplayInfo"));

var DEFAULT_HTTP_TIMEOUT_IN_MS = 15000;
exports.DEFAULT_HTTP_TIMEOUT_IN_MS = DEFAULT_HTTP_TIMEOUT_IN_MS;
var DEFAULT_LINK_CUSTOM_PARAMS = {
  activityType: null,
  availability: new _Availability.default(),
  // only used to store selected time options while editing meeting links
  availabilityTimeList: (0, _immutable.List)(),
  customAvailabilityStartDate: null,
  customAvailabilityEndDate: null,
  description: null,
  displayInfo: new _DisplayInfo.default(),
  durations: new _immutable.List([_dates.ZERO_DURATION]),
  formFields: (0, _immutable.List)(),
  includeDescriptionInReminder: false,
  language: null,
  legalConsentEnabled: false,
  legalConsentOptions: null,
  locale: null,
  location: null,
  meetingBufferTime: _I18n.default.moment.duration('00:15:00').asMilliseconds(),
  ownerPrioritized: false,
  minimumNoticeTime: _I18n.default.moment.duration('00:15:00').asMilliseconds(),
  redirectUrl: null,
  reminders: (0, _immutable.List)(),
  sendReminder: false,
  shouldAutoSubmit: false,
  shouldPrefillFormFields: true,
  subject: null,
  timezone: 'Europe/Dublin',
  videoConferenceExtensionAppId: null,
  weeksToAdvertise: 2,
  startTimeIncrementMinutes: _enums.START_TIME_INTERVALS.FIFTEEN,
  confirmationEmailEnabled: true,
  pushBackTime: _I18n.default.moment.duration('00:15:00').asMilliseconds()
};
exports.DEFAULT_LINK_CUSTOM_PARAMS = DEFAULT_LINK_CUSTOM_PARAMS;